import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../../base/services/base.service";
import {AuthService} from "../../../auth/services/auth.service";
import {NotifierService} from "../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ILeaderboard} from "../models/leaderboard.model";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {IRedeem, IRedeemReq} from "../models/redeem.model";
import {IParams} from "../../../../../../base/endpoints/iparams";
import {IPage} from "../../../../../../base/models/pagination.model";
import {IAchievement} from "../models/achievement.model";
import {AccountingEndpoint} from "../../accounting.endpoint";
import {IAuth} from "../../../../../common/modules/auth/models/auth.model";
@Injectable({
  providedIn: 'root'
})
export class LeaderboardService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBus: EventBusService
  ) {
    super(authService, notifier)
  }

  fetchLeaderboard(key: string, username: string) {
    this.http.get<ILeaderboard>(AccountingEndpoint.LEADERBOARDS.FETCH_LEADERBOARD(username))
      .subscribe((l: ILeaderboard) => {
        this.eventBus.publish(key, l)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchLeaderboard(key, username)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

  redeem(key: string, redeem: IRedeemReq) {
    this.http.post<IRedeem>(AccountingEndpoint.LEADERBOARDS.REDEEM(), redeem)
      .subscribe((redeem: IRedeem) => {
        this.eventBus.publish(key, redeem)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.redeem(key, redeem)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

  fetchRecentAchievements(key: string, params: IParams) {
    this.http.get<IPage<IAchievement>>(AccountingEndpoint.LEADERBOARDS.FETCH_RECENT_ACHIEVEMENTS(params))
      .subscribe((achievements: IPage<IAchievement>) => {
        this.eventBus.publish(key, achievements)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchRecentAchievements(key, params)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

}
